import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { TemplateVariableButtons } from './template-variables';

import { RichTextEditor, type RichTextEditorHandle } from '~/components/common/rich-text-editor';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';

interface Props {
  subject: string;
  body: string;
  onSubjectChange: (value: string) => void;
  onBodyChange: (value: string) => void;
  disabled?: boolean;
}

export function EmailEditor({
  subject,
  body,
  onSubjectChange,
  onBodyChange,
  disabled
}: Props): React.ReactNode {
  const { t } = useTranslation();
  const editorRef = useRef<RichTextEditorHandle>(null);

  function insertIntoBody(variable: string): void {
    editorRef.current?.insertContent(variable);
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1.5">
        <Label className="text-sm">{t('communications.emailSubject')}</Label>
        <Input
          value={subject}
          onChange={(e) => {
            onSubjectChange(e.target.value);
          }}
          disabled={disabled}
        />
      </div>
      <div className="flex flex-col gap-1.5">
        <Label className="text-sm">{t('communications.emailBody')}</Label>
        <RichTextEditor
          ref={editorRef}
          value={body}
          onChange={onBodyChange}
          disabled={disabled}
          placeholder={t('communications.emailBodyPlaceholder')}
        />
      </div>
      <TemplateVariableButtons onInsert={insertIntoBody} disabled={disabled} />
    </div>
  );
}
